import React, { lazy } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import PageHeader from "../../components/PageHeader";
import mainHelper, {
  apiCall,
  getBranches,
  getCustomers
} from "../../helpers/MainHelper";
import ReactLoading from "react-loading";
import logo from "../../assets/images/no-image.png";
import Swal from "sweetalert2";
import withPermissions from "../../components/WithPermissions";
import VehiclesOperationsTable from "../../components/Tables/VehiclesOperationsTable";
import Select from "react-select";
import ServiceImageGallery from "../../components/ServiceImageGallery";

class VehicleDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      branches: [],
      vehicles: [],
      customers: [],
      images: [],
      legacyImages: [],
      showLegacyModal: false,
      loading: false,
      isLoad: true,
      brands: [],
      models: [],
      selectedBrand: '',
      selectedModel: '',
      selectedCustomer: [],
      isDragActive: false,
      vehicleImagePreviews: [],
      formData: {
        id: '',
        brand: '',
        branch_id: '',
        customer_id: '',
        model: '',
        plate: '',
        year: '',
        km: '',
        chassis_no: '',
        engine_no: '',
        package_name: '',
        engine_size: '',
        key_no: '',
        details: '',
        vehicleImages: [],
        maintenance_date: '',
        next_maintenance_date: '',
        inspection_date: '',
        next_inspection_date: '',
        gear_type: '',
      }
    }
    this.vehicleImagesInputRef = React.createRef();
  }
  async componentDidMount() {
    document.body.classList.add(this.props.themeColor);
    this.setState({ isLoad: true }); // Loader'ı başlat

    try {
      await Promise.all([
        this.getBrands(),
        this.getVehicleInfo(),
        getBranches(),
        getCustomers(),
      ]).then(([brands, vehicleInfo, branches, customers]) => {
        this.setState({
          branches,
          customers,
          isLoad: false,
        });
      });
    } catch (e) {
      console.error(e);
      this.setState({ isLoad: false });
    }
  }
  componentDidUpdate(prevProps) {
    if (prevProps.themeColor !== this.props.themeColor) {
      document.body.classList.remove(prevProps.themeColor);
      document.body.classList.add(this.props.themeColor);
    }
  }

  componentWillUnmount() {
    document.body.classList.remove(this.props.themeColor);
  }
  getBrands = async () => {
    const response = await apiCall('business/vehicle/get-brands', 'get', null);
    const brandOptions = response.map(brand => ({
      value: brand.id,
      label: brand.name
    }));
    this.setState({ brands: brandOptions });
  }
  getModels = async (brandID) => {
    const response = await apiCall('business/vehicle/get-models/' + brandID, 'get', null);
    const modelOptions = response.map(brand => ({
      value: brand.id,
      label: brand.name
    }));
    this.setState({ models: modelOptions });
  }

  handleBrandChange = async (selectedOption) => {
    const brand_id = selectedOption.value;
    const option = {
      value: selectedOption.value,
      label: selectedOption.label
    }
    this.setState(prevState => ({
      formData: {
        ...prevState.formData,
        brand: brand_id,
        model: ""
      },
      selectedBrand: option,
      selectedModel: '',
      models: []
    }));

    if (brand_id) {
      try {
        const response = await apiCall(`business/vehicle/get-models/${brand_id}`, 'get', null);

        const modelOptions = response.map(model => ({
          value: model.id,
          label: model.name
        }));
        this.setState({ models: modelOptions });
      } catch (error) {
        console.error("Modelleri alırken hata oluştu:", error);
      }
    }
  }
  handleModelChange = async (selectedOption) => {
    const model_id = selectedOption.value;
    const option = {
      value: selectedOption.value,
      label: selectedOption.label
    }
    this.setState(prevState => ({
      formData: {
        ...prevState.formData,
        model: model_id
      },
      selectedModel: option,
    }));
  }
  getVehicleInfo = async () => {
    const id = this.props.match.params.id;
    try {
      const response = await apiCall('business/vehicle/info/' + id, 'get', null);
      const { formData } = this.state;
      await this.getModels(response.brand.id);
      const updatedFormData = {
        ...formData,
        id: response.id,
        brand: response.brand.id,
        model: response.model.id,
        branch_id: response.branch.id,
        customer_id: response.customer.id,
        plate: response.plate,
        year: response.year,
        km: response.km,
        gen: response.gen,
        gear_type: response.gear_type || '',
        chassis_no: response.chassis_no,
        engine_no: response.engine_no || '',
        package_name: response.package_name || '',
        engine_size: response.engine_size || '',
        key_no: response.key_no || '',
        details: response.details || '',
        vehicleImages: '',
        maintenance_date: response.maintenance[0]?.maintenance_date || '',
        next_maintenance_date: response.maintenance[0]?.next_maintenance_date || '',
        inspection_date: response.inspection[0]?.inspection_date || '',
        next_inspection_date: response.inspection[0]?.next_inspection_date || '',
      };
      let vehicleImages = [];
      let legacyImages = [];

      if (response.images) {
        const images = JSON.parse(response.images);
        const storageType = response.storage_type || 'local';

        if (storageType === 's3') {
          // Sadece S3 resimleri - Ana gallery'de göster
          if (response.image_urls && response.image_urls.length > 0) {
            vehicleImages = response.image_urls.map((url, index) => ({
              original: url,
              thumbnail: url,
              name: images[index] || `image_${index}`,
              storage: 's3'
            }));
          }
        } else if (storageType === 'local') {
          // Eski local resimler - "Eski Resimler" butonunda göster
          const baseURL = 'https://apizone.servicezone.com.tr/images/vehicle/';
          legacyImages = images.map(image => ({
            original: `${baseURL}${image}`,
            thumbnail: `${baseURL}${image}`,
            name: `${image}`,
            storage: 'local'
          }));
        }
      }

      if (vehicleImages.length === 0) {
        vehicleImages.push({
          original: logo,
          thumbnail: logo,
          name: "logo-icon.png",
        });
      }
      const selectedBrandOption = {
        value: response.brand.id,
        label: response.brand.name,
      }
      const selectedModelOption = {
        value: response.model.id,
        label: response.model.name,
      }
      const selectedCustomer = {
        value: response.customer.id,
        label: response.customer.name + ' ' + response.customer.surname,
      }
      this.setState({
        images: vehicleImages,
        legacyImages: legacyImages,
        formData: updatedFormData,
        selectedBrand: selectedBrandOption,
        selectedModel: selectedModelOption,
        selectedCustomer: selectedCustomer,
      });
    } catch (e) {
      this.setState({ isLoad: false })
    } finally {
      this.setState({ isLoad: false });
    }
  }
  handleChange = (e) => {
    const { id, value, files } = e.target;
    this.setState(prevState => ({
      formData: {
        ...prevState.formData,
        [id]: files ? Array.from(files) : value
      }
    }));
  }
  handleCustomerChange = (selectedCustomer) => {
    const formattedSelectedOptions = {
      value: selectedCustomer.value,
      label: selectedCustomer.label
    } || {};

    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        customer_id: formattedSelectedOptions.value
      },
      selectedCustomer: formattedSelectedOptions
    }));
  };
  handleVehicleImagesSelect = (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    this.setState((prev) => {
      const newFiles = [...(prev.formData.vehicleImages || []), ...files];
      const newPreviews = [...prev.vehicleImagePreviews, ...files.map(f => ({ url: URL.createObjectURL(f), name: f.name }))];
      return {
        formData: {
          ...prev.formData,
          vehicleImages: newFiles,
        },
        vehicleImagePreviews: newPreviews,
      };
    });
  }
  handleVehicleImagesDrop = (e) => {
    e.preventDefault();
    const files = Array.from(e.dataTransfer.files || []).filter(f => f.type.startsWith('image/'));
    if (!files.length) return;
    this.setState((prev) => {
      const newFiles = [...(prev.formData.vehicleImages || []), ...files];
      const newPreviews = [...prev.vehicleImagePreviews, ...files.map(f => ({ url: URL.createObjectURL(f), name: f.name }))];
      return {
        formData: {
          ...prev.formData,
          vehicleImages: newFiles,
        },
        isDragActive: false,
        vehicleImagePreviews: newPreviews,
      };
    });
  }
  handleVehicleImagesDragOver = (e) => {
    e.preventDefault();
    if (!this.state.isDragActive) this.setState({ isDragActive: true });
  }
  handleVehicleImagesDragLeave = () => {
    if (this.state.isDragActive) this.setState({ isDragActive: false });
  }
  handleRemoveVehicleImage = (index) => {
    this.setState((prev) => {
      const files = [...(prev.formData.vehicleImages || [])];
      const previews = [...prev.vehicleImagePreviews];
      files.splice(index, 1);
      const removed = previews.splice(index, 1);
      if (removed[0]?.url) URL.revokeObjectURL(removed[0].url);
      return {
        formData: {
          ...prev.formData,
          vehicleImages: files,
        },
        vehicleImagePreviews: previews,
      };
    });
  }
  handleSubmit = async (e) => {
    e.preventDefault();
    this.setState({ loading: true });
    const { formData } = this.state;
    const vehicleFormData = new FormData();

    Object.keys(formData).forEach(key => {
      if (key === 'vehicleImages' && Array.isArray(formData[key]) && formData[key].length > 0) {
        // Yeni araç görselleri - File objelerini gönder
        console.log('vehicleImages Array:', formData[key]);
        formData[key].forEach((file, index) => {
          console.log(`vehicleImages[${index}]:`, file, 'is File?', file instanceof File);
          if (file instanceof File) {
            console.log(`✅ Appending file: ${file.name} (${file.size} bytes)`);
            vehicleFormData.append('vehicleImages[]', file);
          } else {
            console.log(`❌ NOT A FILE: ${typeof file}`, file);
          }
        });
      } else if (Array.isArray(formData[key])) {
        formData[key].forEach(item => {
          vehicleFormData.append(`${key}[]`, item);
        });
      } else {
        vehicleFormData.append(key, formData[key]);
      }
    });

    console.log('=== DEBUG INFO ===');
    console.log('Gönderilen vehicleImages sayısı:', formData.vehicleImages?.length || 0);
    console.log('FormData entries:');
    for (let pair of vehicleFormData.entries()) {
      console.log(pair[0], ':', pair[1] instanceof File ? `File: ${pair[1].name}` : pair[1]);
    }

    try {
      const response = await apiCall('business/vehicle/update/' + formData.id, 'post', vehicleFormData);
      this.setState({ loading: false });

      // Başarılı olursa preview'ları temizle ve sayfayı yenile
      if (response.status === 'success') {
        this.setState({ vehicleImagePreviews: [] });
        await this.getVehicleInfo(); // Yeni resimleri göster
      }

      mainHelper.toastMessage(response.status, response.message);
    } catch (e) {
      this.setState({ loading: false });
    }

  }
  handleImageDelete = async (name) => {
    const { formData, images } = this.state;
    const prevImgData = images;
    const updatedImages = images.filter(image => image.name !== name);
    const result = await Swal.fire({
      title: 'Silmek istediğinize emin misiniz?',
      text: "Bu işlem geri alınamaz!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Evet, sil!',
      cancelButtonText: 'Hayır, iptal et'
    });

    if (result.isConfirmed) {
      try {

        await apiCall('business/vehicle/delete-image', 'post', { vehicleID: formData.id, name: name })
        if (updatedImages.length === 0) {
          this.setState({ images: [{ original: logo, thumbnail: logo, name: "logo-icon.png" }] });
        } else {
          this.setState({ images: updatedImages });
        }
        Swal.fire(
          'Silindi!',
          'Resim başarıyla silindi.',
          'success'
        );
      } catch (error) {
        mainHelper.toastMessage('error', 'Resim silinirken bir hata oluştu.')
        this.setState({ images: prevImgData });
        Swal.fire(
          'Hata!',
          'Silme işlemi başarısız oldu.',
          'error'
        );
      }
    }
  };

  render() {
    const { formData, branches, customers, loading, images, legacyImages, showLegacyModal, brands, models, selectedBrand, selectedModel, selectedCustomer } = this.state;
    const { userPermissions } = this.props;
    const userHasUpdateVehiclePermission = userPermissions.includes('update vehicle');
    const inspection = formData.inspection_date.split(' ')[0];
    const next_inspection = formData.next_inspection_date.split(' ')[0];
    const maintenance = formData.maintenance_date.split(' ')[0];
    const next_maintenance = formData.next_maintenance_date.split(' ')[0];
    const { themeColor } = this.props;
    const formattedOptions = customers.map(option => ({
      value: option.id,
      label: option.name + ' ' + option.surname
    }));
    return (
      <div
        style={{ flex: 1 }}
        onClick={() => {
          document.body.classList.remove("offcanvas-active");
        }}
      >
        <div>
          <div className="container-fluid">
            <PageHeader
              HeaderText="Araç detayları"
              Breadcrumb={[
                { name: "Araçlar", navigate: "vehicles" },
                { name: "Detay", navigate: "" },
              ]}
            />
            <div className="page-loader-wrapper" style={{ display: this.state.isLoad ? 'block' : 'none' }}>
              <div className="loader" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <div className="m-t-30">
                  <img src={require('../../assets/images/logo-white.png')} width="150" alt="Lucid" />
                </div>
                <p>Yükleniyor</p>
                <ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff" />
              </div>
            </div>
            <div className="row clearfix">
              <div className="col-lg-12">
                <div className="card">
                  <div className="row clearfix mt-3">
                    <div className="col-lg-6 col-md-12">
                      <div className="preview">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <h6 className="mb-0"></h6>
                          {legacyImages.length > 0 && (
                            <button
                              className="btn btn-sm btn-outline-warning"
                              onClick={() => this.setState({ showLegacyModal: !showLegacyModal })}
                            >
                              <i className="icon-folder"></i> Eski Resimler ({legacyImages.length})
                            </button>
                          )}
                        </div>
                        <ServiceImageGallery
                          images={images}
                          title="Araç Resimleri"
                          loading={lazy}
                          userHasDeletePermission={userPermissions.includes('delete service vehicle image')}
                          onImageDelete={this.handleImageDelete}
                        />

                        {/* Eski Resimler Modal */}
                        {showLegacyModal && legacyImages.length > 0 && (
                          <div className="card mt-3" style={{ border: '2px solid #ffc107' }}>
                            <div className="card-header bg-warning">
                              <h6 className="mb-0">
                                <i className="icon-folder"></i> Eski Resimler
                                <button
                                  className="btn btn-sm btn-outline-dark float-right"
                                  onClick={() => this.setState({ showLegacyModal: false })}
                                >
                                  <i className="icon-close"></i>
                                </button>
                              </h6>
                            </div>
                            <div className="card-body">
                              <div className="row">
                                {legacyImages.map((img, index) => (
                                  <div key={index} className="col-md-4 col-sm-6 mb-3">
                                    <div style={{ position: 'relative' }}>
                                      <img
                                        src={img.thumbnail}
                                        alt={img.name}
                                        style={{
                                          width: '100%',
                                          height: '150px',
                                          objectFit: 'cover',
                                          borderRadius: '5px',
                                          cursor: 'pointer'
                                        }}
                                        onClick={() => window.open(img.original, '_blank')}
                                      />
                                      <small className="text-muted d-block mt-1" style={{ fontSize: '10px' }}>
                                        {img.name}
                                      </small>
                                    </div>
                                  </div>
                                ))}
                              </div>
                              <div className="alert alert-info mb-0">
                                <i className="icon-info"></i> Bu resimler eski sistemden gelmektedir.
                                Yeni yüklenen tüm resimler S3'e kaydedilmektedir.
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-12">
                      <h6>Servis Geçmişi</h6>
                      {this.state.formData.id ?
                        <VehiclesOperationsTable
                          vehicleID={formData.id}
                        ></VehiclesOperationsTable>
                        : ""}
                    </div>
                  </div>
                  <form className="form" id="vehicleData" onSubmit={this.handleSubmit} encType='multipart/form-data' style={{ display: "contents" }}>
                    <div className="body">
                      <div className="row clearfix">
                        <div className="col-lg-6 col-md-12">

                          <h6>Araç Bilgileri</h6>
                          <div className="form-group">
                            <label htmlFor="customer_id" className={`font-weight-bold ${themeColor}`}>
                              Müşteri
                            </label>
                            <Select
                              placeholder="Müşteri Seçiniz..."
                              options={formattedOptions}
                              value={selectedCustomer}
                              onChange={this.handleCustomerChange}
                            />
                          </div>
                          <div className="form-group">
                            <label htmlFor="branch_id" className="font-weight-bold text-cyan">
                              Şube
                            </label>
                            <select name="branch_id" id='branch_id'
                              className="form-control"
                              value={formData.branch_id}
                              onChange={this.handleChange}>
                              <option value="">Şube Seçiniz</option>
                              {branches && (branches.map(branch => (
                                <option key={branch.id}
                                  value={branch.id}>{branch.name}</option>
                              )))}

                            </select>
                          </div>

                          <div className="form-group">
                            <label htmlFor="plate" className="font-weight-bold text-cyan">
                              Plaka
                            </label>
                            <input name="plate"
                              id="plate"
                              className="form-control"
                              placeholder="Plaka"
                              type="text"
                              value={formData.plate}
                              onChange={this.handleChange}
                            />
                          </div>
                          <div className="form-group">
                            <label htmlFor="brand" className="font-weight-bold text-cyan">
                              Marka
                            </label>
                            <Select
                              value={selectedBrand}
                              onChange={this.handleBrandChange}
                              options={brands}
                              placeholder="Marka Seçin"
                              styles={{
                                control: (provided, state) => ({
                                  ...provided,
                                  borderColor: state.isFocused ? 'red' : 'red',
                                  boxShadow: state.isFocused ? '0 0 0 1px red' : 'none',
                                  '&:hover': { borderColor: 'red' }
                                })
                              }}
                            />
                          </div>
                          <div className="form-group">
                            <label htmlFor="model" className="font-weight-bold text-cyan">
                              Model
                            </label>
                            <Select
                              value={selectedModel}
                              onChange={this.handleModelChange}
                              options={models}
                              placeholder="Model Seçin"
                              styles={{
                                control: (provided, state) => ({
                                  ...provided,
                                  borderColor: state.isFocused ? 'red' : 'red',
                                  boxShadow: state.isFocused ? '0 0 0 1px red' : 'none',
                                  '&:hover': { borderColor: 'red' }
                                })
                              }}
                            />
                          </div>
                          <div className="form-group">
                            <label htmlFor="year" className="font-weight-bold text-cyan">
                              Model yılı
                            </label>
                            <input name="year"
                              id="year"
                              className="form-control"
                              placeholder="Model Yılı"
                              type="number"
                              value={formData.year}
                              onChange={this.handleChange}
                            />
                          </div>
                          <div className="form-group">
                            <label htmlFor="gen" className="font-weight-bold text-cyan">
                              Nesil
                            </label>
                            <input name="vehicleData.gen"
                              id="gen"
                              className="form-control"
                              placeholder="F30, Megane 4 , Clio 3 vs..."
                              type="text"
                              value={formData.gen}
                              onChange={this.handleChange}
                            />
                          </div>
                          <div className="form-group">
                            <label htmlFor="details" className="font-weight-bold text-cyan">
                              Araç detayları
                            </label>
                            <textarea name="details"
                              id="details"
                              className="form-control"
                              placeholder="Araç detayları"
                              value={formData.details}
                              onChange={this.handleChange}
                            />

                          </div>
                          <div className="form-group">
                            <label htmlFor="maintenance" className="font-weight-bold text-cyan">
                              Bakım tarihi
                            </label>
                            <input name="maintenance_date"
                              id="maintenance_date"
                              className="form-control"
                              type="date"
                              value={maintenance || ""}
                              onChange={this.handleChange}
                            />
                          </div>
                          <div className="form-group">
                            <label htmlFor="inspection" className="font-weight-bold text-cyan">
                              Muayene tarihi
                            </label>
                            <input name="inspection_date"
                              id="inspection_date"
                              className="form-control"
                              type="date"
                              value={inspection || ""}
                              onChange={this.handleChange}
                            />
                          </div>

                        </div>
                        <div className="col-lg-6 col-md-12">

                          <h6>&nbsp;</h6>
                          <div className="form-group">
                            <label htmlFor="gear_type" className="font-weight-bold text-cyan">
                              Vites Tipi
                            </label>
                            <select name="gear_type" id='gear_type'
                              className="form-control"
                              value={formData.gear_type}
                              onChange={this.handleChange}>
                              <option value="">Vites Tipi Seçiniz</option>
                              <option value="otomatik">Otomatik</option>
                              <option value="manuel">Manuel</option>

                            </select>
                          </div>
                          <div className="form-group">
                            <label htmlFor="engine_no" className="font-weight-bold text-cyan">
                              Motor No
                            </label>
                            <input name="engine_no"
                              id="engine_no"
                              className="form-control"
                              placeholder="Motor No"
                              type="number"
                              value={formData.engine_no}
                              onChange={this.handleChange}
                            />
                          </div>
                          <div className="form-group">
                            <label htmlFor="engine_size" className="font-weight-bold text-cyan">
                              Motor hacmi
                            </label>
                            <input name="engine_size"
                              id="engine_size"
                              className="form-control"
                              placeholder="Motor Hacmi"
                              type="text"
                              value={formData.engine_size}
                              onChange={this.handleChange}
                            />
                          </div>
                          <div className="form-group">
                            <label htmlFor="km" className="font-weight-bold text-cyan">
                              Km
                            </label>
                            <input name="km"
                              id="km"
                              className="form-control"
                              placeholder="Km"
                              type="number"
                              value={formData.km}
                              onChange={this.handleChange}
                            />
                          </div>
                          <div className="form-group">
                            <label htmlFor="chassis_no" className="font-weight-bold text-cyan">
                              Şase No
                            </label>
                            <input name="chassis_no"
                              id="chassis_no"
                              className="form-control"
                              placeholder="Şase No"
                              type="text"
                              value={formData.chassis_no}
                              onChange={this.handleChange}
                            />
                          </div>
                          <div className="form-group">
                            <label htmlFor="package_name" className="font-weight-bold text-cyan">
                              Paket adı
                            </label>
                            <input name="package_name"
                              id="package_name"
                              className="form-control"
                              placeholder="Paket Adı"
                              type="text"
                              value={formData.package_name}
                              onChange={this.handleChange}
                            />
                          </div>
                          <div className="form-group">
                            <label htmlFor="key_no" className="font-weight-bold text-cyan">
                              Anahtar No
                            </label>
                            <input name="key_no"
                              id="key_no"
                              className="form-control"
                              placeholder="Anahtar No"
                              type="text"
                              value={formData.key_no}
                              onChange={this.handleChange}
                            />
                          </div>

                          <div className="form-group">
                            <label htmlFor="next_maintenance" className="font-weight-bold text-cyan">
                              Sonraki bakım tarihi
                            </label>
                            <input name="next_maintenance_date"
                              id="next_maintenance_date"
                              className="form-control"
                              type="date"
                              value={next_maintenance || ""}
                              onChange={this.handleChange}
                            />
                          </div>
                          <div className="form-group">
                            <label htmlFor="next_inspection" className="font-weight-bold text-cyan">
                              Sonraki muayene tarihi
                            </label>
                            <input name="next_inspection_date"
                              id="next_inspection_date"
                              className="form-control"
                              type="date"
                              value={next_inspection || ""}
                              onChange={this.handleChange}
                            />
                          </div>

                        </div>
                      </div>

                      <div className="row clearfix">
                        <div className="col-lg-12">
                          <div className="form-group">
                            <label className="font-weight-bold text-cyan">Araç Görselleri Ekle</label>
                            <div
                              onDragOver={this.handleVehicleImagesDragOver}
                              onDragLeave={this.handleVehicleImagesDragLeave}
                              onDrop={this.handleVehicleImagesDrop}
                              onClick={() =>
                                this.vehicleImagesInputRef.current && this.vehicleImagesInputRef.current.click()
                              }
                              className="text-center"
                              style={{
                                border: '2px dashed #ced4da',
                                borderRadius: 6,
                                padding: 16,
                                cursor: 'pointer',
                                backgroundColor: this.state.isDragActive ? '#f8f9fa' : 'transparent',
                                textAlign: 'center',
                              }}
                            >
                              <div>Dosyaları buraya sürükleyip bırakın ya da tıklayıp seçin</div>
                              <small className="text-muted">
                                Sadece görsel dosyalar (birden fazla seçebilirsiniz)
                              </small>
                              <input
                                ref={this.vehicleImagesInputRef}
                                type="file"
                                accept="image/*"
                                multiple
                                style={{ display: 'none' }}
                                onChange={this.handleVehicleImagesSelect}
                              />
                            </div>

                            {this.state.vehicleImagePreviews && this.state.vehicleImagePreviews.length > 0 && (
                              <div className="d-flex flex-wrap mt-2" style={{ gap: 10 }}>
                                {this.state.vehicleImagePreviews.map((p, idx) => (
                                  <div key={idx} style={{ position: 'relative' }}>
                                    <img
                                      src={p.url}
                                      alt={p.name}
                                      style={{
                                        width: 90,
                                        height: 90,
                                        objectFit: 'cover',
                                        borderRadius: 6,
                                        border: '1px solid #e9ecef',
                                      }}
                                    />
                                    <button
                                      type="button"
                                      className="btn btn-outline-danger btn-sm"
                                      style={{ position: 'absolute', top: -10, right: -10 }}
                                      onClick={() => this.handleRemoveVehicleImage(idx)}
                                    >
                                      <i className="icon-trash" />
                                    </button>
                                  </div>
                                ))}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="body">
                        <div className="row clearfix justify-content-center">
                          <div className="col-lg-6 col-md-12">
                            {loading ? (
                              <button className="btn btn-outline-primary btn-block"
                                disabled={true}
                                style={{ textAlign: "-webkit-center" }}>
                                Lütfen Bekleyin...<ReactLoading type="spin"
                                  width={'24px'}
                                  height={'24px'}
                                  color="#268bd2"></ReactLoading>
                              </button>
                            ) :
                              <button disabled={!userHasUpdateVehiclePermission}
                                className="btn btn-outline-primary btn-block"
                                type="submit">
                                Güncelle
                              </button>}

                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    );
  }
}

const mapStateToProps = (state) => {
  const { themeColor } = state.navigationReducer;
  return { themeColor };
};

export default withPermissions(withRouter(connect(mapStateToProps, {})(VehicleDetail)));
